module.exports = __webpack_public_path__ + "static/media/boat.835684b7.gif";